/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForAzureKubernetesUserManagedIndividual extends models.StorageConfigurationForAzureKubernetesUserManaged {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForAzureKubernetesUserManagedIndividual");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForAzureKubernetesUserManagedIndividual.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForAzureKubernetesUserManagedIndividual>): StorageConfigurationForAzureKubernetesUserManagedIndividual {
        let obj = Object.assign(new StorageConfigurationForAzureKubernetesUserManagedIndividual(), model);
        StorageConfigurationForAzureKubernetesUserManagedIndividual.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForAzureKubernetesUserManagedIndividual>): StorageConfigurationForAzureKubernetesUserManagedIndividual {
        if (!model) return null;
        return StorageConfigurationForAzureKubernetesUserManagedIndividual.newInstance(<StorageConfigurationForAzureKubernetesUserManagedIndividual> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForAzureKubernetesUserManagedIndividual) {
        if (!obj) return;

        models.StorageConfigurationForAzureKubernetesUserManagedIndividual.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForAzureKubernetesUserManagedIndividual): boolean {
        if (models.StorageConfigurationForAzureKubernetesUserManaged.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForAzureKubernetesUserManagedIndividual.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
